// extracted by mini-css-extract-plugin
module.exports = {"dataRow":"DataTable_dataRow__2mbf2"};